export const LOCALES = {
  RUSSIAN: "ru",
  UKRAINIAN: "uk",
};

export const LOCALES_LABELS = {
  RUSSIAN: "RU",
  UKRAINIAN: "UA",
};